import React, { useContext, useEffect, useState } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { UserContext } from '../../App';
import { BookOverview } from '../../components/dashboard/soldBook/bookOverview';
import { InsertTracking } from '../../components/dashboard/insertTracking';
import { BuyerDetails } from '../../components/dashboard/soldBook/buyerDetails';
import { Label } from '../../components/dashboard/soldBook/label';
import { Alert, BookSold } from '../../components/dashboard/alert';
import { PaymentDetails } from '../../components/dashboard/soldBook/payment';
import { LoadingFull } from '../../components/loading';
import { Status } from '../../components/dashboard/soldBook/status';
import { OrderOverview } from '../../components/dashboard/soldBook/orderOverview';

const ConfirmBook = () => {

  const { dbId } = useParams();
  const [data, setData] = useState();
  const [ownsBook, setOwnsBook] = useState();
  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const navigate = useNavigate()
  const { auth, user, setUser } = useContext(UserContext)
  const token = localStorage.getItem('token')
  
  useEffect(() => {
    axios.get('/api/orderDetails', {
      headers: {
        'dbId': dbId,
        Authorization: `Bearer ${token}`
      }
    })
    .then(response => {
      setData(response.data);
    })
    .catch(error => {
      navigate('/')
    });
  }, []);

  if (!auth) {
    return <Navigate to="/login" />
  }

  return (
    <div id="container" className="innerContainer mx-auto flex gap-x-10 py-[104px] md:py-[106px]">
      {(typeof data === 'undefined') ?
        <LoadingFull />
      : (data.dbBook.ejer === user._id && data.dbBook.status !== 0) ?
        <div className="w-full">
          <div className="h-full flex flex-col gap-y-5 justify-between">
            {(data.dbBook.status === 1 || data.dbBook.status === 2) ?
              <BookSold dbBook={data.dbBook} apiBook={data.apiBook} />
            :
              ""}
            <div className="flex gap-5 flex-col md:flex-row h-auto">
              {(data.dbBook.status === 2) ?
                <BuyerDetails dbBook={data.dbBook} soldBook={data.soldBook} />
              :
                <Status dbBook={data.dbBook} soldBook={data.soldBook} />}
              <OrderOverview dbBook={data.dbBook} soldBook={data.soldBook} apiBook={data.apiBook} />
            </div>
          </div>
        </div>
      :
        <Navigate to="/" />
      }
    </div>
  )
}


export default ConfirmBook;